import ReactComponent from "../../app/ReactComponent";
import {Steps, Radio, Input, Button, Col, Space, Card, Result} from "antd";
import {AP_SURVEY_QUESTIONS} from "../../helpers/misc_survey"
import Query from "../../app/Query";
import {PROPERTY_AP_SURVEY_KEY} from "../../helpers/properties";
import React from "react";

export function YesOrNoRadios(props) {
  return (
    <Radio.Group name={props.skey} value={props.questions[props.skey].answer} onChange={(data) => {
      props.setSurveyAnswer({[props.skey]: data.target.value})
    }}>
      <Radio value={true}>Ano</Radio>
      <Radio value={false}>Ne</Radio>
    </Radio.Group>
  )
}

export function SurveyTextarea(props) {
  return (
    <div className="textarea-container">
      <label>{props.gender !== "2" ? props.questions[props.skey].question : props.questions[props.skey].question_female}</label>
      <Input.TextArea rows={3} name={props.skey} value={props.questions[props.skey].answer} onChange={(data) => {
        props.setSurveyAnswer({[props.skey]: data.target.value})
      }}/>
    </div>
  )
}


export class Survey extends ReactComponent {

  state = {
    loading_page: false,
    current: 0,
    bigQuestions: [25],
    questions: AP_SURVEY_QUESTIONS,
  }

  async getDataForForm(event_type_id) {

    void this.updateState({loading_page: true})

    try {

      const {segment_records = []} = await this.$api({
        action: 'carecloud_user_api',
        route: 'segment-records'
      })

      const query = new Query('events')

      query.add('event_type_id', event_type_id)
      query.add('sort_field', 'created_at')
      query.add('sort_direction', 'desc')

      const res = await this.$api({
        action: 'carecloud_api',
        route: query.route
      })
      const events = res.events || []
      console.log(res)

      const {event_id = false} = (events.at(0) ?? false)

      if (event_id) {

        const {property_records = []} = await this.$api({
          action: 'carecloud_api',
          route: `events/${event_id}/property-records`
        })

        const {property_value: survey_data = false} = (property_records.find(({property_id}) => property_id === PROPERTY_AP_SURVEY_KEY) ?? false)


        if (survey_data) {

          this.setSurveyData(JSON.parse(survey_data))

        }

      }

      void this.updateState({segments: segment_records})


    } catch (error) {

      console.log(error)

    } finally {

      void this.updateState({loading_page: false})

    }

  }

  setSurveyData(data) {
    let questions = {}

    data.forEach((item, index) => {

      let {answer} = item

      if (answer === "Ano") answer = true
      if (answer === "Ne") answer = false
      if (answer === "Nevyplněno") answer = undefined

      void this.updateState({[item.question]: answer})

      questions[item.question] = {
        ...this.state.questions[item.question],
        answer: answer
      }

    })

    this.setState((prevState) => ({
      ...prevState,
      questions: {
        ...prevState.questions,
        ...questions
      }
    }))

  }

  getSurveyData() {

    let result = []

    Object.keys(this.state.questions).forEach((item) => {

      let answer = this.state.questions[item].answer

      if (answer === true) answer = "Ano"
      if (answer === false) answer = "Ne"
      if (answer === undefined) answer = "Nevyplněno"

      if (answer !== null)
        result.push({question: item, answer: answer})

    })

    return result
  }

  setSurveyAnswer = async (question)=> {

    let key = Object.keys(question)[0] || null
    let value = question[key]

    await this.updateState(question)
    await this.updateState({
      questions: {
        ...this.state.questions,
        [key]: {
          ...this.state.questions[key],
          answer: value
        }
      }
    })

    /** Empty subquestions */
    if((value === false && key !== "q28") || (key === "q28" && value === true)) {

      let keysToBeEmpty = Object.keys(this.state.questions).filter((element) => (new RegExp(`^${key}[a-z][0-9a-z]{0,3}`)).test(element))

      keysToBeEmpty.forEach((item) => {

        this.setState((prevState) => ({
          ...prevState,
          [item]: undefined,
          questions: {
            ...prevState.questions,
            [item]: {
              ...prevState.questions[item],
              answer: undefined
            }
          }
        }))

      })

    }
  }

  changeSurveyStep = (data) => {
    void this.updateState({current: data})
  }

  scrollToActiveStep = () => {
    const activeStepElement = document.querySelector(".ant-steps-item-active")
    const isBigQuestion = this.state.bigQuestions.includes(this.state.current)

    if(activeStepElement)
      activeStepElement.scrollIntoView({behavior: "smooth", block: isBigQuestion ? "start" :"center"})

    if(isBigQuestion)
      setTimeout(() => {
        window.scrollBy({behavior: "smooth", top: -80})
      }, 300)
  }

  nextStep = async () => {
    const currentNextStep = this.state.current + 1
    await this.updateState({current: currentNextStep})

    this.scrollToActiveStep()
  }

  prevStep = async () => {
    const currentPrevStep = this.state.current - 1
    await this.updateState({current: currentPrevStep})

    this.scrollToActiveStep()
  }
}